import * as Types from 'apps/shared/scripts/__generated__/graphql.generated';

import { gql } from '@apollo/client';
export type PostFragment = { readonly __typename: 'Post', readonly createdAt: any, readonly id: string, readonly message?: string | null, readonly name: string, readonly updatedAt: any, readonly author?: { readonly __typename: 'Profile', readonly id: string, readonly name: string } | null, readonly media?: { readonly __typename: 'Media', readonly src: string, readonly type: Types.MediaType } | null };

export const PostFragmentDoc = gql`
    fragment PostFragment on Post {
  author {
    id
    name
  }
  createdAt
  id
  media {
    src
    type
  }
  message
  name
  updatedAt
}
    `;